import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    id: 1,
    question: "Comment trouver un bon marabout en Belgique ?",
    answer: "Un bon marabout se reconnaît par son sérieux, son expérience (plus de 20 ans), sa discrétion absolue et ses résultats concrets. Nous offrons des services professionnels dans toute la Belgique avec un taux de réussite de 95%."
  },
  {
    id: 2,
    question: "Comment faire revenir mon ex rapidement ?",
    answer: "Le retour affectif est notre spécialité. Grâce aux rituels de magie blanche et rouge, nous aidons à faire revenir l'être aimé. Les résultats apparaissent généralement dans la même semaine selon la complexité de votre situation."
  },
  {
    id: 3,
    question: "Comment récupérer ma femme ou mon mari après une séparation ?",
    answer: "Nous utilisons des rituels puissants de retour de l'être aimé pour récupérer votre conjoint. Nos méthodes de magie africaine traditionnelle ont aidé de nombreux couples à se retrouver."
  },
  {
    id: 4,
    question: "Le marabout est-il discret ?",
    answer: "Oui, la discrétion absolue est garantie. Toutes vos consultations et rituels restent confidentiels. Nous respectons votre vie privée et votre situation."
  },
  {
    id: 5,
    question: "Quels types d'envoûtements proposez-vous ?",
    answer: "Nous pratiquons l'envoûtement d'amour, la magie blanche pour l'harmonie, la magie rouge pour la passion, ainsi que des rituels de protection et de désenvoûtement. Chaque rituel est personnalisé selon vos besoins."
  },
  {
    id: 6,
    question: "Comment sauver mon couple en crise ?",
    answer: "Nous proposons des rituels pour sauver votre couple, renforcer l'amour et l'harmonie, éliminer la jalousie et l'infidélité. Notre expertise permet de résoudre les problèmes de couple avec efficacité."
  },
  {
    id: 7,
    question: "Où intervenez-vous en Belgique ?",
    answer: "Nous intervenons dans toute la Belgique : Bruxelles, Anvers, Gand, Liège, Charleroi, Bruges, Namur, Louvain, Mons et toutes les autres villes belges. Consultations disponibles en personne ou à distance."
  },
  {
    id: 8,
    question: "Combien de temps prennent les résultats ?",
    answer: "Les résultats apparaissent généralement dans la même semaine. La rapidité varie selon la complexité de votre situation. Chaque cas est unique et traité avec une attention personnalisée."
  }
];

const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 md:py-32 px-4 relative overflow-hidden bg-black">
      <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            Questions <span className="gold-text">Fréquentes</span>
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto serif-font">
            Toutes les réponses à vos questions sur nos services de maraboutage
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <div 
              key={faq.id}
              className="glass rounded-2xl overflow-hidden hover:bg-white/10 transition-all"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="w-full flex justify-between items-center p-6 text-left"
              >
                <h3 className="text-lg md:text-xl font-bold text-white pr-8">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  {openId === faq.id ? (
                    <ChevronUp className="text-yellow-500" size={28} />
                  ) : (
                    <ChevronDown className="text-yellow-500" size={28} />
                  )}
                </div>
              </button>
              
              {openId === faq.id && (
                <div className="px-6 pb-6 animate-fadeInUp">
                  <div className="border-t border-white/10 pt-4">
                    <p className="text-gray-300 text-lg leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-400 mb-6">
            Vous avez d'autres questions ? Contactez-nous directement
          </p>
          <a 
            href="#contact"
            className="inline-flex items-center space-x-3 luxury-button text-white px-10 py-5 rounded-full font-bold text-lg"
          >
            <span>Nous Contacter</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;